import { FC, useEffect, useState } from 'react'
import mclasses from '../../../../styles/modal.module.css'
import iclasses from '../../../../styles/input.module.css'
import gclasses from '../../../../../CRMSettings/global.module.css'
import classes from './index.module.css'
import cn from 'classnames'
import Button from '@UI/New/Button'
import { useAddAlert } from '@/hooks/useAddAlert'
import { Lead, Notification } from '@/api/types/crm.types'
import { notificationsMock } from '@pages/Admin/CRMSettings/mockData'
import { crmApi } from '@/api'
import { isError } from '@/helpers/checkQuery'
import Preloader from '@UI/Preloader'
import SendNotificationModal from './SendNotificationModal'

interface NotificationButtonListProps {
  lead: Lead
}

const NotificationButtonList: FC<NotificationButtonListProps> = ({ lead }) => {
  const addAlert = useAddAlert()

  const [data, setData] = useState<Notification[]>(notificationsMock) // FIXME: delete mock (notificationsMock -> [])
  const [loading, setLoading] = useState(false)

  const [sendModal, setSendModal] = useState<Notification | null>(null)

  const handlerLoadNotifications = () => {
    setLoading(true)
    crmApi
      .getAllNotifications({ type: 'button' })
      .then((res) => {
        if (isError(res)) throw new Error()
        setData(res.data.data)
      })
      .catch(() => {
        // FIXME: включить обратно
        // addAlert({
        //   title: 'Ошибка',
        //   text: 'Не удалось загрузить список уведомлений',
        //   type: 'error',
        // })
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    handlerLoadNotifications()
  }, [])

  return (
    <div className={cn('custom-scroll', classes.list)}>
      {loading ? (
        <div className={classes.preloaderWrapper}>
          <Preloader fullScreen="app" />
        </div>
      ) : (
        data.map((item) => (
          <Button
            key={item.id}
            color="secondary"
            className={classes.button}
            onClick={() => setSendModal(item)}
          >
            {item.name}
          </Button>
        ))
      )}

      {/* Modals */}
      <SendNotificationModal
        lead={lead}
        notification={sendModal}
        open={sendModal !== null}
        onClose={() => setSendModal(null)}
        onSuccess={() => setSendModal(null)}
      />
    </div>
  )
}

export default NotificationButtonList
